import styled from 'styled-components';

const SSpinerWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export default SSpinerWrap